import UserSymbolContainer from './UserSymbol.container';
import UserSymbol from './UserSymbol';
export default UserSymbolContainer(UserSymbol);
